import * as Yup from 'yup'

export const getValidationSchema = () =>
  Yup.object().shape({
    truckId: Yup.number(),
    truckNumber: Yup.string(),
    deliveryTicketId: Yup.number().nullable(),
    ticketNumber: Yup.string().nullable(),
    supportId: Yup.number(),
    supportCode: Yup.string(),
    productId: Yup.number(),
    productEan: Yup.string(),
    productEans: Yup.string(),
    productName: Yup.string(),
    conformQuantity: Yup.number(),
    defectQuantity: Yup.number(),
    defectReason: Yup.string(),
    mark: Yup.string(),
    shopReceptionDeviation: Yup.number().nullable()
  })

export const initialValues = {}
